<template>
  <el-container class="menulist">
    <div class="menulist-top">
      <el-button type="success" @click="addfather()">添加目录</el-button>
    </div>
    <el-main class="menulist-content">
      <el-table :data="tableData5" type="selection">
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-table class="demo-table-expand" :data="scope.row.children" border style="width: 100%">
              <el-table-column type="expand">
                <template slot-scope="scope">
                  <el-table class="demo-table-expand" :data="scope.row.children" border style="width: 100%">
                    <el-table-column prop="parentId" label="所属目录ID">
                    </el-table-column>
                    <el-table-column prop="id" label="ID">
                    </el-table-column>
                    <el-table-column align="center" prop="name" label="按钮名"> </el-table-column>
                    <el-table-column align="center" prop="type" label="类型">
                      <template
                        slot-scope="scope">{{ scope.row.type == 'C'? '目录':scope.row.type == 'M' ?'菜单': scope.row.type == 'B'? '按钮': ""}}</template>
                    </el-table-column>
                    <el-table-column align="center" label="操作">
                      <template slot-scope="scope">
                        <el-button size="mini" type="success" @click="editResource(scope.row)">修改
                        </el-button>
                        <el-button size="mini" type="danger" @click="delResource(scope.row)">删除
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </el-table-column>
              <el-table-column prop="parentId" label="所属目录ID">
              </el-table-column>
              <el-table-column prop="id" label="ID">
              </el-table-column>
              <el-table-column align="center" prop="name" label="菜单名"> </el-table-column>
              <el-table-column align="center" prop="component" label="路由"> </el-table-column>
              <el-table-column align="center" prop="type" label="菜单类型">
                <template slot-scope="scope">{{ scope.row.type == 'C'? '目录':scope.row.type == 'M' ?'菜单':''}}</template>
              </el-table-column>
              <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                  <el-button size="mini" type="success" @click="addResource(scope.row)">新增资源
                  </el-button>
                  <el-button size="mini" type="success" @click="sonhand(scope.row)">修改
                  </el-button>
                  <el-button size="mini" type="danger" @click="sondel(scope.row)">删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column align="center" label="ID" prop="id">
        </el-table-column>
        <el-table-column align="center" label="目录名" prop="name">
        </el-table-column>
        <el-table-column align="center" label="路由" prop="component">
        </el-table-column>
        <el-table-column label="类型" prop="type">
          <template slot-scope="scope">{{ scope.row.type == 'C'? '目录':scope.row.type == 'M' ?'菜单':''}}</template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="400">
          <template slot-scope="scope">
            <el-button size="mini" type="success" @click="fatheradd(scope.row)">添加子菜单
            </el-button>
            <el-button size="mini" type="success" @click="fatherhand(scope.row)">修改
            </el-button>
            <el-button size="small" type="danger" @click="fatherdel(scope.row)">删除 </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <!-- 添加子菜单弹出框 -->
    <div class="menulist-add">
      <el-drawer title="我是标题" :visible.sync="drawer1" :with-header="false">
        <div class="title">菜单详情</div>
        <el-form :model="addlist" ref="addlist" label-width="100px" class="demo-ruleForm" size="mini">
          <el-form-item label="菜单所属ID" prop="parentId">
            <el-input v-model="addlist.id" disabled></el-input>
          </el-form-item>
          <el-form-item label="菜单名称" prop="name">
            <el-input v-model="addlist.name"></el-input>
          </el-form-item>
          <el-form-item label="菜单路由" prop="name">
            <el-input v-model="addlist.component"></el-input>
          </el-form-item>
          <el-form-item label="客户端code" prop="clientCode">
            <el-input v-model="clientCode" disabled></el-input>
          </el-form-item>
          <el-form-item label="请求路径" prop="name">
            <el-button size="mini" style="margin-bottom:5px" @click="addPostUrl">添加多条路径</el-button>
            <div style="display: flex;margin-bottom:5px" v-for="(item,index) in resourceUrlDTOList" :key="index">
              <el-select v-model="item.method" placeholder="请选择方式">
                <el-option label="POST" value="POST"></el-option>
                <el-option label="GET" value="GET"></el-option>
                <el-option label="PUT" value="PUT"></el-option>
                <el-option label="DELETE" value="DELETE"></el-option>
              </el-select>
              <el-input v-model="item.apiUri" placeholder="请输入请求路径" style="margin-right: 20px"></el-input>
              <el-button type="danger" size="mini" @click="delPostUrl(index)">删除</el-button>
            </div>
          </el-form-item>
          <el-form-item label="是否显示" prop="visible">
            <el-switch v-model="addlist.visible"></el-switch>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addsubmitForm('ruleForm')">添加</el-button>
            <el-button @click="addresetForm('ruleForm')">退出</el-button>
          </el-form-item>
        </el-form>
      </el-drawer>
    </div>
    <!-- 新增资源弹出框 -->
    <div class="resource-add">
      <el-drawer title="我是标题" :visible.sync="resourceDrawer" :with-header="false">
        <div class="title" style="text-align: center;margin: 20px 0px;font-size: 16px;font-weight: bold">新增资源</div>
        <el-form :model="resourceList" ref="addlist" label-width="100px" class="demo-ruleForm" size="mini">
          <el-form-item label="所属上级ID" prop="parentId">
            <el-input v-model="resourceList.id" disabled></el-input>
          </el-form-item>
          <el-form-item label="按钮名称" prop="name">
            <el-input v-model="resourceList.name"></el-input>
          </el-form-item>
          <el-form-item label="客户端code" prop="clientCode">
            <el-input v-model="clientCode" disabled></el-input>
          </el-form-item>
          <el-form-item label="请求路径" prop="name">
            <el-button size="mini" style="margin-bottom:5px" @click="addPostUrl">添加多条路径</el-button>
            <div style="display: flex;margin-bottom:5px" v-for="(item,index) in resourceUrlDTOList" :key="index">
              <el-select v-model="item.method" placeholder="请选择方式">
                <el-option label="POST" value="POST"></el-option>
                <el-option label="GET" value="GET"></el-option>
                <el-option label="PUT" value="PUT"></el-option>
                <el-option label="DELETE" value="DELETE"></el-option>
              </el-select>
              <el-input v-model="item.apiUri" placeholder="请输入请求路径" style="margin-right: 20px"></el-input>
              <el-button type="danger" size="mini" @click="delPostUrl(index)">删除</el-button>
            </div>
          </el-form-item>
          <el-form-item label="是否显示" prop="visible">
            <el-switch v-model="resourceList.visible"></el-switch>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="updateResource('ruleForm')">添加</el-button>
            <el-button @click="resourceDrawer = false">退出</el-button>
          </el-form-item>
        </el-form>
      </el-drawer>
    </div>
    <!-- 修改资源弹出框 -->
    <div class="resource-edit">
      <el-drawer title="我是标题" :visible.sync="editResourceDrawer" :with-header="false">
        <div class="title" style="text-align: center;margin: 20px 0px;font-size: 16px;font-weight: bold">新增资源</div>
        <el-form :model="editResourceList" ref="addlist" label-width="100px" class="demo-ruleForm" size="mini">
          <el-form-item label="所属上级ID" prop="parentId">
            <el-input v-model="editResourceList.parentId" disabled></el-input>
          </el-form-item>
          <el-form-item label="按钮名称" prop="name">
            <el-input v-model="editResourceList.name"></el-input>
          </el-form-item>
          <el-form-item label="客户端code" prop="clientCode">
            <el-input v-model="clientCode" disabled></el-input>
          </el-form-item>
          <el-form-item label="请求路径" prop="name">
            <el-button size="mini" style="margin-bottom:5px" @click="addPostUrl">添加多条路径</el-button>
            <div style="display: flex;margin-bottom:5px" v-for="(item,index) in resourceUrlDTOList" :key="index">
              <el-select v-model="item.method" placeholder="请选择方式">
                <el-option label="POST" value="POST"></el-option>
                <el-option label="GET" value="GET"></el-option>
                <el-option label="PUT" value="PUT"></el-option>
                <el-option label="DELETE" value="DELETE"></el-option>
              </el-select>
              <el-input v-model="item.apiUri" placeholder="请输入请求路径" style="margin-right: 20px"></el-input>
              <el-button type="danger" size="mini" @click="delPostUrl(index)">删除</el-button>
            </div>
          </el-form-item>
          <el-form-item label="是否显示" prop="visible">
            <el-switch v-model="editResourceList.visible"></el-switch>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="updateEditResource('ruleForm')">修改</el-button>
            <el-button @click="editResourceDrawer = false">退出</el-button>
          </el-form-item>
        </el-form>
      </el-drawer>
    </div>
    <!-- 修改父级菜单弹出框 -->
    <div class="menulist-add">
      <el-drawer title="我是标题" :visible.sync="drawer" :with-header="false">
        <div class="title">菜单详情</div>
        <el-form :model="editlist" ref="editlist" label-width="100px" class="demo-ruleForm">
          <el-form-item label="ID" prop="id">
            <el-input v-model="editlist.id" disabled></el-input>
          </el-form-item>
          <el-form-item label="目录名" prop="name">
            <el-input v-model="editlist.name"></el-input>
          </el-form-item>
          <el-form-item label="路由" prop="component">
            <el-input v-model="editlist.component"></el-input>
          </el-form-item>
          <el-form-item label="icon" prop="icon">
            <el-input v-model="editlist.icon" disabled></el-input>
          </el-form-item>
          <el-form-item label="客户端code" prop="clientCode">
            <el-input v-model="clientCode" disabled></el-input>
          </el-form-item>
          <el-form-item label="是否启用" prop="visible">
            <el-switch v-model="editlist.visible"></el-switch>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onedit('ruleForm')">完成</el-button>
            <el-button @click="outedit('ruleForm')">退出</el-button>
          </el-form-item>
        </el-form>
      </el-drawer>
    </div>
    <!-- 修改子级菜单弹出框 -->
    <div class="menulist-add">
      <el-drawer title="我是标题" :visible.sync="drawer2" :with-header="false">
        <div class="title">菜单详情</div>
        <el-form :model="editsonlist" ref="editlist" label-width="100px" class="demo-ruleForm" size="mini">
          <el-form-item label="ID" prop="id">
            <el-input v-model="editsonlist.id" disabled></el-input>
          </el-form-item>
          <el-form-item label="菜单名称" prop="name">
            <el-input v-model="editsonlist.name"></el-input>
          </el-form-item>
          <el-form-item label="菜单路由" prop="component">
            <el-input v-model="editsonlist.component"></el-input>
          </el-form-item>
          <el-form-item label="客户端code" prop="clientCode">
            <el-input v-model="clientCode" disabled></el-input>
          </el-form-item>
          <el-form-item label="请求路径" prop="name">
            <el-button size="mini" style="margin-bottom:5px" @click="addPostUrl">添加多条路径</el-button>
            <div style="display: flex;margin-bottom:5px" v-for="(item,index) in resourceUrlDTOList" :key="index">
              <el-select v-model="item.method" placeholder="请选择方式">
                <el-option label="POST" value="POST"></el-option>
                <el-option label="GET" value="GET"></el-option>
                <el-option label="PUT" value="PUT"></el-option>
                <el-option label="DELETE" value="DELETE"></el-option>
              </el-select>
              <el-input v-model="item.apiUri" placeholder="请输入请求路径" style="margin-right: 20px"></el-input>
              <el-button type="danger" size="mini" @click="delPostUrl(index)">删除</el-button>
            </div>
          </el-form-item>
          <el-form-item label="是否启用" prop="visible">
            <el-switch v-model="editsonlist.visible"></el-switch>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="sonedit('ruleForm')">完成</el-button>
            <el-button size="mini" @click="outsonedit('ruleForm')">退出</el-button>
          </el-form-item>
        </el-form>
      </el-drawer>
    </div>
    <!-- 添加目录弹出框 -->
    <div class="menulist-add">
      <el-drawer title="我是标题" :visible.sync="drawer3" :with-header="false">
        <div class="title">添加目录</div>
        <el-form :model="addfatherlist" ref="editlist" label-width="100px" class="demo-ruleForm">
          <el-form-item label="目录名" prop="name">
            <el-input v-model="addfatherlist.name"></el-input>
          </el-form-item>
          <el-form-item label="路由" prop="component">
            <el-input v-model="addfatherlist.component"></el-input>
          </el-form-item>
          <el-form-item label="客户端code" prop="clientCode">
            <el-select v-model="addfatherlist.clientCode" clearable size="mini">
              <el-option label="manager" value="manager"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addfatherliston('ruleForm')">完成</el-button>
            <el-button @click="addfatherlistout('ruleForm')">退出</el-button>
          </el-form-item>
        </el-form>
      </el-drawer>
    </div>
  </el-container>
</template>

<script>
import {
  api_permissionlist,
  api_edilpermissionlist,
  api_addpermissionlist,
  api_delpermissionlist,
  api_edit_btn
} from "@/api/adm.js";
export default {
  data() {
    return {
      //总数据
      clientCode: "manager", //客户端code
      tableData5: [],
      addfatherlist: {}, //添加目录菜单数据
      addlist: {
        name: "",
        component: "",
        type: "",
        visible: true
      }, //添加子菜单数据
      resourceList: {}, //添加资源菜单数据
      editlist: {}, //修改父级菜单数据
      editResourceList: {}, //修改三级菜单弹窗数据
      editsonlist: {}, //修改子级菜单数据
      drawer1: false, //添加菜单弹出框
      drawer: false, //修改父级菜单弹出框
      editResourceDrawer: false, //修改三级菜单弹窗
      drawer2: false, //修改子级菜单弹出框
      drawer3: false, //添加目录弹出框
      resourceDrawer: false,
      resourceUrlDTOList: [{ apiUri: "", method: "" }] //动态生成input
    };
  },
  methods: {
    //修改三级菜单
    async editResource(row) {
      this.editResourceDrawer = true;
      let res = await api_edit_btn(row.id);
      this.editResourceList = res.data;
      this.resourceUrlDTOList = res.data.resourceUrlVOList;
    },
    //修改三级菜单提交按钮
    async updateEditResource() {
      let res = await api_edilpermissionlist({
        clientCode: this.clientCode,
        type: "B",
        name: this.editResourceList.name,
        parentId: this.editResourceList.parentId,
        resourceUrlDTOList: this.resourceUrlDTOList,
        visible: this.editResourceList.visible,
        id: this.editResourceList.id
      });
      if (res.code == 0) {
        this.$message({
          message: "成功",
          type: "success"
        });
        this.permissionlist(); //重绘视图
        this.editResourceDrawer = false;
      } else {
        this.$message.error(res.message);
      }
    },
    //删除三级菜单
    delResource(row) {
      this.$confirm("是否要删除父菜单", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        customClass: "message-confirm-style"
      }).then(async () => {
        let res = await api_delpermissionlist(row.id);
        if (res.code == 0) {
          this.$message({
            message: "成功",
            type: "success"
          });
          this.permissionlist(); //重绘视图
        } else {
          this.$message.error("失败");
        }
      });
    },
    //新增资源按钮
    addResource(row) {
      this.resourceList.id = row.id;
      this.resourceDrawer = true;
    },
    //新增资源弹窗提交按钮
    async updateResource() {
      this.resourceList.type = "B";
      let res = await api_addpermissionlist({
        clientCode: this.clientCode,
        parentId: this.resourceList.id,
        type: this.resourceList.type,
        resourceUrlDTOList: this.resourceUrlDTOList,
        visible: this.resourceList.visible,
        name: this.resourceList.name
      });
    },
    //添加子菜单请求路径input 添加按钮
    addPostUrl() {
      let obj = { apiUri: "", method: "" };
      this.resourceUrlDTOList.push(obj);
    },
    //添加子菜单请求路径input 删除按钮
    delPostUrl(index) {
      this.resourceUrlDTOList.splice(index, 1);
    },
    //添加目录
    addfather(row) {
      this.drawer3 = true;
      this.addfatherlist = { ...row };
      this.addfatherlist.type = "C";
    },
    //添加目录提交按钮
    async addfatherliston() {
      if (!this.addfatherlist.name || !this.addfatherlist.component) {
        this.$message.error("目录名与路由不能为空");
      } else {
        let res = await api_addpermissionlist(this.addfatherlist);
        if (res.code == 0) {
          this.$message({
            message: "成功",
            type: "success"
          });
          this.permissionlist(); //重绘菜单试图
          this.drawer3 = false;
        } else {
          this.$message.error("失败");
        }
      }
    },
    //添加目录退出按钮
    addfatherlistout() {
      this.drawer3 = false;
    },
    //父级菜单修改按钮
    fatherhand(row) {
      this.clientCode = row.clientCode;
      this.drawer = true;
      this.editlist = { ...row };
    },
    //父级修改弹窗完成按钮
    async onedit() {
      let res = await api_edilpermissionlist(this.editlist);
      if (res.code == 0) {
        this.$message({
          message: "成功",
          type: "success"
        });
        this.permissionlist(); //重绘视图
        this.drawer = false;
      } else {
        this.$message.error("失败");
      }
    },
    //父级修改弹窗退出按钮
    outedit() {
      this.drawer = false;
    },
    //父级菜单删除按钮
    fatherdel(row) {
      this.$confirm("是否要删除父菜单", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        customClass: "message-confirm-style"
      }).then(async () => {
        let res = await api_delpermissionlist(row.id);
        if (res.code == 0) {
          this.$message({
            message: "成功",
            type: "success"
          });
          this.permissionlist(); //重绘视图
        } else {
          this.$message.error("失败");
        }
      });
    },
    //父级菜单添加子菜单按钮
    fatheradd(row) {
      this.clientCode = row.clientCode;
      this.drawer1 = true;
      this.addlist.id = row.id;
      this.addlist.type = "M";
      this.addlist.name = "";
      this.addlist.component = "";
      this.addlist.type = "";
      this.resourceUrlDTOList = [{ apiUri: "", method: "" }];
    },
    //添加子菜单提交按钮
    async addsubmitForm() {
      if (this.addlist.name == "" || this.addlist.component == "") {
        this.$message.error("请全部填写完成后创建");
        return false;
      } else {
        let res = await api_addpermissionlist({
          clientCode: this.clientCode,
          name: this.addlist.name,
          component: this.addlist.component,
          type: this.addlist.type,
          visible: this.addlist.visible,
          parentId: this.addlist.id,
          resourceUrlDTOList: this.resourceUrlDTOList
        });
        if (res.code == 0) {
          this.$message({
            message: "成功",
            type: "success"
          });
          this.permissionlist(); //重绘菜单试图
          this.drawer1 = false;
        } else {
          this.$message.error("失败");
        }
      }
    },
    //添加子菜单退出按钮
    addresetForm() {
      this.drawer1 = false;
    },
    //子级菜单修改按钮
    async sonhand(row) {
      let res = await api_edit_btn(row.id);
      this.editResourceList = res.data;
      this.resourceUrlDTOList = res.data.resourceUrlVOList;
      this.drawer2 = true;
      this.editsonlist = { ...row };
    },
    //子级菜单修改弹出框提交按钮
    async sonedit() {
      let res = await api_edilpermissionlist({
        type: "M",
        clientCode: this.clientCode,
        name: this.editsonlist.name,
        parentId: this.editsonlist.parentId,
        resourceUrlDTOList: this.resourceUrlDTOList,
        visible: this.editsonlist.visible,
        id: this.editsonlist.id
      });
      if (res.code == 0) {
        this.$message({
          message: "成功",
          type: "success"
        });
        this.permissionlist(); //重绘菜单试图
        this.drawer2 = false;
      } else {
        this.$message.error("失败");
      }
    },
    //子级菜单弹出框退出按钮
    outsonedit() {
      this.drawer2 = false;
    },
    //子级菜单删除按钮
    async sondel(row) {
      this.$confirm("是否要删除子菜单", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        customClass: "message-confirm-style"
      }).then(async () => {
        let res = await api_delpermissionlist(row.id);
        if (res.code == 0) {
          this.$message({
            message: "成功",
            type: "success"
          });
          this.permissionlist(); //重绘菜单试图
        } else {
          this.$message.error("失败");
        }
      });
    },
    //获取当前所有路由菜单
    async permissionlist() {
      let res = await api_permissionlist();
      this.tableData5 = res.data;
    },
    //菜单启用停用启用停用
    statusFormatter(row, column) {
      let disabled = row.visible;
      if (disabled === false) {
        return "否";
      } else {
        return "是";
      }
    }
  },
  mounted() {
    this.permissionlist(); //获取数据
  }
};
</script>


<style lang="less" scoped>
.menulist {
  height: 100%;
  display: flex;
  flex-direction: column;
  .menulist-top {
    margin-bottom: 16px;
    padding: 20px;
    background: #fff;
  }
  .menulist-content {
    margin: 0 16px;
    padding: 10px 20px;
    background: #fff;
  }
  .menulist-add {
    .title {
      font-size: 26px;
      font-weight: bolder;
      color: blueviolet;
      text-align: center;
      margin-top: 30px;
      margin-bottom: 30px;
    }
  }
}
</style>


